import { DateProperty, DropdownProperty, NumberProperty, TextProperty } from './Property';
import ValueLabel from './ValueLabel';

enum FilterType {
  Date = 'Date',
  Text = 'Text',
  Number = 'Number',
  Dropdown = 'Dropdown',
}

interface DateFilter {
  type: FilterType.Date;
  property: DateProperty;
  hasError: boolean;
  open: boolean;
  from: string;
  to: string;
}

interface TextFilter {
  type: FilterType.Text;
  property: TextProperty;
  hasError: boolean;
  open: boolean;
  relation: ValueLabel;
  value: string;
}

interface NumberFilter {
  type: FilterType.Number;
  property: NumberProperty;
  hasError: boolean;
  open: boolean;
  relation: ValueLabel;
  value: string;
}

interface DropdownFilter {
  type: FilterType.Dropdown;
  property: DropdownProperty;
  hasError: boolean;
  open: boolean;
  /**
   * The operator/relation of the filter (e.g. equals, not equals, less than, contains, etc.)
   */
  relation: ValueLabel;
  value: ValueLabel;
}

type Filter = DateFilter | TextFilter | NumberFilter | DropdownFilter;

export { DateFilter, TextFilter, NumberFilter, DropdownFilter, FilterType };
export default Filter;
